module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    " + _vm._s(_vm.data.content) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88aa178c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Paragraph.vue
// module id = 1767
// module chunks = 0